import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-698550af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = { class: "pricing-plan-area pt-120 mb-120" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row g-4 mb-70 justify-content-center align-items-center" }
const _hoisted_9 = { class: "col-lg-12 col-md-12" }
const _hoisted_10 = {
  class: "pricing-plan-card1 mx-2 bg-card1",
  style: {"height":"50em"}
}
const _hoisted_11 = { class: "pricing-plan-header" }
const _hoisted_12 = { class: "starting-form" }
const _hoisted_13 = { style: {"background-color":"#010536","color":"white","min-height":"5rem"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/site-fav.png",
  alt: "",
  width: "35"
}, null, -1))
const _hoisted_15 = { class: "price-area" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "priceing-list h-fix mb-4" }
const _hoisted_18 = { class: "icon" }
const _hoisted_19 = {
  key: 0,
  style: {"color":"#010536","margin-right":"1em"}
}
const _hoisted_20 = {
  key: 1,
  style: {"color":"#010536","margin-right":"1em"}
}
const _hoisted_21 = {
  key: 0,
  class: "d-flex justify-content-center mt-5"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 3,
  class: "primry-btn-2 custom-btn lg-btn",
  type: "button"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "d-flex justify-content-center mt-5"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 3,
  class: "primry-btn-2 custom-btn lg-btn",
  type: "button"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-698550af><div class=\"col-lg-12\" data-v-698550af><div class=\"add-area\" data-v-698550af><p data-v-698550af><span data-v-698550af>Special Offer for First Time Users!</span> New to WORKPAGES? Post your first job for FREE!</p></div><div class=\"add-area\" style=\"gap:1em;\" data-v-698550af><p data-v-698550af>Click below to claim your offer:</p><a class=\"primry-btn-1\" href=\"#\" data-v-698550af>Post a job for free</a></div></div><div class=\"col-lg-12\" data-v-698550af><div class=\"advertuse-area\" data-v-698550af><h4 data-v-698550af>Why Choose WORKPAGES for Your Business Advertising?</h4><ul data-v-698550af><li data-v-698550af><p data-v-698550af><span data-v-698550af>Wide Audience Reach: </span> Showcase your jobs to diverse and active audience</p></li><li data-v-698550af><p data-v-698550af><span data-v-698550af>Simple Job Posting: </span> Post jobs effortlessly and quickly</p></li><li data-v-698550af><p data-v-698550af><span data-v-698550af>Extensive CV Database: </span>Find the right candidates with access to a large pool of CVs</p></li><li data-v-698550af><p data-v-698550af><span data-v-698550af>Active Recruiter Network: </span>Connect with a growing community of bussinesses and recruites</p></li><li data-v-698550af><p data-v-698550af><span data-v-698550af>High Job Engagement: </span>Get your job posts noticed by the right candidates</p></li></ul></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_Splide = _resolveComponent("Splide")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Pricing Plan", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Splide, {
            options: {
                        type: 'loop', perPage: 3, pagination: false, breakpoints: {
                            1068: { perPage: 2 }, // For screens <= 768px
                            768: { perPage: 1 }, // For screens <= 576px
                        }
                    },
            "aria-label": "My Favorite Images"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPlans, (plan, index) => {
                return (_openBlock(), _createBlock(_component_SplideSlide, {
                  key: 'plan-'+plan.id+'-'+index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, [
                              _hoisted_14,
                              _createTextVNode(" " + _toDisplayString(plan.name), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("h3", null, "WST $" + _toDisplayString(plan.price), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("ul", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.keypoints, (point) => {
                              return (_openBlock(), _createElementBlock("li", null, [
                                _createElementVNode("div", _hoisted_18, [
                                  (point.icon !== null || point.icon !== '')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(point.icon), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_20, "✖"))
                                ]),
                                _createElementVNode("p", null, _toDisplayString(point.title), 1)
                              ]))
                            }), 256))
                          ])
                        ]),
                        (this.paymentMethodCreditCard == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              (this.activePlanId == null && !plan.isLoading && plan.price > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.checkout(plan)),
                                    class: "primry-btn-2 custom-btn lg-btn",
                                    type: "button"
                                  }, _toDisplayString(this.loggedIn == true ? 'Buy Now' : 'Login To Buy'), 9, _hoisted_22))
                                : _createCommentVNode("", true),
                              (this.activePlanId !== null && !plan.isLoading && plan.price > 0 && this.activePlanId == plan.id)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "primry-btn-2 custom-btn lg-btn",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.unsubscribe(plan))
                                  }, "Unsubscribe ", 8, _hoisted_23))
                                : _createCommentVNode("", true),
                              (!plan.isLoading && plan.price == 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    onClick: ($event: any) => (_ctx.zeroSubscribe(plan)),
                                    class: "primry-btn-2 custom-btn lg-btn",
                                    type: "button"
                                  }, _toDisplayString(this.loggedIn ==
                                            true ? 'Buy Now':'Login To Buy'), 9, _hoisted_24))
                                : _createCommentVNode("", true),
                              (plan.isLoading)
                                ? (_openBlock(), _createElementBlock("button", _hoisted_25, _hoisted_28))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (this.activePlanId == null && !plan.isLoading && plan.price > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.subscribePackage(plan)),
                                    class: "primry-btn-2 custom-btn lg-btn",
                                    type: "button"
                                  }, _toDisplayString(this.loggedIn == true ? 'Subscribe Now' : 'Login To Buy'), 9, _hoisted_30))
                                : _createCommentVNode("", true),
                              (this.activePlanId !== null && !plan.isLoading && plan.price > 0 && this.activePlanId == plan.id)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "primry-btn-2 custom-btn lg-btn",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.unsubscribe(plan))
                                  }, "Unsubscribe ", 8, _hoisted_31))
                                : _createCommentVNode("", true),
                              (!plan.isLoading && plan.price == 0 && this.activePlanId == null)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    onClick: ($event: any) => (_ctx.zeroSubscribe(plan)),
                                    class: "primry-btn-2 custom-btn lg-btn",
                                    type: "button"
                                  }, _toDisplayString(this.loggedIn ==
                                            true ? 'Subscribe Now':'Login To Buy'), 9, _hoisted_32))
                                : _createCommentVNode("", true),
                              (plan.isLoading)
                                ? (_openBlock(), _createElementBlock("button", _hoisted_33, _hoisted_36))
                                : _createCommentVNode("", true)
                            ]))
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _hoisted_37
      ])
    ])
  ]))
}